import React from 'react';
import MyBooksSvg from '@/assets/icons/mybooks.svg?react';

interface MyBooksIconProps {
  className?: string;
  size?: number;
}

const MyBooksIcon: React.FC<MyBooksIconProps> = ({ className = "w-7 h-7", size }) => {
  return (
    <MyBooksSvg
      className={className}
      width={size}
      height={size}
    />
  );
};

export default MyBooksIcon;
